module.exports = __webpack_public_path__ + "static/media/Board of Studies_2019-20.0ce536b8.pdf";